import { Controller } from "@hotwired/stimulus";

export default class FormController extends Controller {
  submit() {
    if (this.element.requestSubmit) {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }
}
